import { CodNegocio } from '@dinnisoft/esteio-gestao-common';
import { Fields } from 'types/table';
import { getSexoOption, sexoOptionsArr } from 'utils/getSexoOption';

export const getLoteFields = async (field: any, selectedFazenda: any): Promise<Fields[]> => {
  const getAreaOptionsURL = async () => {
    let codAreaOptionsURL = `areas/area=null&codFazenda=${selectedFazenda?.codFazenda}&finalizado=0&forrageira=1&pastagem=1&data=null&confinamento=false&pastagemAtual=null`;

    if (field?.codTipoCriacao != 3) {
      codAreaOptionsURL = `areas/area=null&codFazenda=${selectedFazenda?.codFazenda}&finalizado=0&forrageira=1&pastagem=1&data=null&confinamento=false&pastagemAtual=null`;
    } else {
      codAreaOptionsURL = `areas/area=null&codFazenda=${selectedFazenda?.codFazenda}&finalizado=0&forrageira=null&pastagem=null&data=null&confinamento=true&pastagemAtual=null`;
    }

    return codAreaOptionsURL;
  };

  const fields: Fields[] = [
    {
      name: 'codFazenda',
      label: 'codFazenda',
      type: 'hidden',
      defaultValue: selectedFazenda.codFazenda,
    },
    // TODO: Permitir que se insira números no campo.
    // Está pegando a máscara sem o defaultValue estar como maskedField?.nome
    {
      name: 'nome',
      label: 'Nome',
      type: 'text',
      defaultValue: field?.nome,
      sm: 12,
      md: 6,
      isRequired: true,
      shouldMask: false,
    },
    {
      name: 'descricao',
      label: 'Descrição',
      type: 'text',
      defaultValue: field?.descricao,
      sm: 12,
      md: 3,
    },
    {
      name: 'abreviacao',
      label: 'Abreviação',
      type: 'text',
      defaultValue: field?.abreviacao,
      sm: 12,
      md: 3,
      isRequired: true,
    },
    {
      name: 'sexo',
      label: 'Sexo',
      type: 'inputSelect',
      options: sexoOptionsArr,
      defaultValue: field?.sexo
        ? getSexoOption(field?.sexo)
        : sexoOptionsArr.find((item) => item.sexo === 'Femea'),
      isRequired: true,
      sm: 12,
      md: 4,
    },
    {
      type: 'inputSelect',
      name: 'codFase',
      label: selectedFazenda?.codNegocio === CodNegocio.leite ? 'Fase' : 'Fase inicial',
      options: `fases/${selectedFazenda?.codNegocio}`,
      optionLabel: (option: any) => option?.nome ?? '',
      renderOption: (props: any, option: any) => (
        <span {...props} key={option.codFase}>
          {option.nome}
        </span>
      ),
      defaultValue: field?.codFase ?? '1',
      isRequired: true,
      disableOnEdit: selectedFazenda?.codNegocio === CodNegocio.leite ? false : true,
      sm: 12,
      md: 4,
    },
  ];

  const corteFields: Fields[] = [
    {
      type: 'inputSelect',
      name: 'codTipoCriacao',
      label: 'Tipo de Criação',
      options: 'conftipocriacao',
      optionLabel: (option: any) => option?.nome ?? '',
      renderOption: (props: any, option: any) => (
        <span {...props} key={option.codTipoCriacao}>
          {option.nome}
        </span>
      ),
      defaultValue: field?.codTipoCriacao ?? '1',
      disableOnEdit: true,
      sm: 12,
      md: 4,
    },
    {
      type: 'inputSelect',
      name: 'codArea',
      label: field?.codTipoCriacao != 3 ? 'Pastagem Inicial' : 'Área Inicial',
      options: field?.codTipoCriacao
        ? await getAreaOptionsURL()
        : `areas/area=null&codFazenda=${selectedFazenda?.codFazenda}&finalizado=0&forrageira=1&pastagem=1&data=null&confinamento=false&pastagemAtual=null`,
      optionLabel: (option: any) => option?.nome ?? '',
      renderOption: (props: any, option: any) => (
        <span {...props} key={option.codArea}>
          {option.nome}
        </span>
      ),
      defaultValue: field?.codArea,
      disableOnEdit: true,
      sm: 12,
      md: 6,
    },
    {
      name: 'dataEntrada',
      label: 'Data de Entrada',
      type: 'date',
      defaultValue: new Date(),
      disableFutureDates: true,
      isRequired: true,
      disableOnEdit: true,
      sm: 6,
      md: 6,
    },
  ];

  const criacaoNaoConfinamento: Fields[] = [
    {
      name: 'alturaEntrada',
      label: 'Altura de Entrada (cm)',
      type: 'text',
      defaultValue: field?.loteArea?.alturaEntrada,
      disableOnEdit: true,
      shouldMask: true,
      sm: 12,
      md: 6,
    },
  ];

  // Itens do menu para fazenda de corte
  if (selectedFazenda?.codNegocio !== CodNegocio.leite) {
    // Item para Tipo de Criação de "Confinamento"
    if (field?.codTipoCriacao != 3) {
      corteFields.push(...criacaoNaoConfinamento);
    }

    fields.push(...corteFields);
  }

  return fields;
};
